module.exports = __webpack_public_path__ + "img/33e9543.png";